var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c("b-card-title", [_vm._v("Document")]),
              !_vm.viewOnly
                ? _c(
                    "b-row",
                    { staticClass: "mb-2" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-1", attrs: { md: "12" } },
                        [
                          _c("b-form-file", {
                            ref: "fileInput",
                            staticClass: "mt-2 d-none",
                            attrs: {
                              placeholder: "Choose files or drop them here...",
                              "drop-placeholder": "Drop files here...",
                              multiple: "",
                            },
                            on: { change: _vm.handleFileSelect },
                          }),
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-between" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-2",
                                  attrs: { variant: "info" },
                                  on: { click: _vm.openFilePicker },
                                },
                                [_vm._v("Select Files")]
                              ),
                              _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    target: "file-tooltip",
                                    placement: "bottom",
                                  },
                                },
                                [
                                  _vm._v(
                                    " Max file upload at a time is 10, and max size is 20 MB. "
                                  ),
                                ]
                              ),
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-2",
                                  attrs: { variant: "success" },
                                  on: { click: _vm.uploadFiles },
                                },
                                [_vm._v("Upload Files")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "my-2", attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            label: "Filter by File Name",
                            "label-for": "fileNameFilter",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "fileNameFilter",
                                  placeholder: "Type to filter by file name...",
                                },
                                model: {
                                  value: _vm.fileNameFilter,
                                  callback: function ($$v) {
                                    _vm.fileNameFilter = $$v
                                  },
                                  expression: "fileNameFilter",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "outline-danger" },
                                      on: { click: _vm.clearFilter },
                                    },
                                    [_vm._v(" Clear ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-list-group",
                { attrs: { flush: "" } },
                _vm._l(_vm.selectedFiles, function (file, index) {
                  return _c(
                    "b-list-group-item",
                    {
                      key: index + 100,
                      staticClass:
                        "d-flex justify-content-between align-items-center my-2",
                    },
                    [
                      _vm._v(" " + _vm._s(file.name) + " "),
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "danger" },
                          on: {
                            click: function ($event) {
                              return _vm.removeFile(index)
                            },
                          },
                        },
                        [_vm._v("Remove")]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c("b-table", {
                attrs: {
                  items: _vm.filteredFiles,
                  fields: _vm.fields,
                  striped: "",
                  responsive: "",
                  "sort-by": "fileName",
                  "sort-desc": "false",
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(view_document)",
                    fn: function (row) {
                      return [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "vs-checkbox-con",
                            attrs: { plain: "" },
                            on: { change: row.toggleDetails },
                            model: {
                              value: row.detailsShowing,
                              callback: function ($$v) {
                                _vm.$set(row, "detailsShowing", $$v)
                              },
                              expression: "row.detailsShowing",
                            },
                          },
                          [
                            _c("span", { staticClass: "vs-checkbox" }),
                            _c("span", { staticClass: "vs-label" }, [
                              _vm._v(
                                _vm._s(row.detailsShowing ? "Hide" : "Show")
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "row-details",
                    fn: function (row) {
                      return [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c(
                                  "b-card",
                                  { staticClass: "bg-transparent mb-5" },
                                  [
                                    _c(
                                      "b-card-header",
                                      {
                                        staticClass: "justify-content-end px-0",
                                      },
                                      [
                                        _c(
                                          "b-dropdown",
                                          {
                                            staticClass: "chart-dropdown",
                                            attrs: {
                                              variant: "link",
                                              "no-caret": "",
                                              "toggle-class": "p-0",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "button-content",
                                                  fn: function () {
                                                    return [
                                                      _c("feather-icon", {
                                                        staticClass:
                                                          "text-body cursor-pointer",
                                                        attrs: {
                                                          icon: "MoreVerticalIcon",
                                                          size: "18",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyToClipboard(
                                                      row.item.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Copy URL ")]
                                            ),
                                            _vm.documentDetails.isDelete
                                              ? _c(
                                                  "b-dropdown-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.$emit(
                                                          "deleteFile",
                                                          row.item.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Delete")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-card-body",
                                      [
                                        _c(
                                          "b-row",
                                          {
                                            staticClass:
                                              "justify-content-center align-items-center",
                                          },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "d-flex flex-column justify-content-center align-items-center text-center",
                                                attrs: { md: "6" },
                                              },
                                              [
                                                _c("feather-icon", {
                                                  attrs: {
                                                    icon: "FolderIcon",
                                                    size: "50",
                                                  },
                                                }),
                                                _c("b-card-text", [
                                                  _vm._v(
                                                    _vm._s(row.item.fileName)
                                                  ),
                                                ]),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "clipboard-container",
                                                  },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          size: "sm",
                                                          variant:
                                                            "outline-secondary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downloadnew(
                                                              row.item.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("feather-icon", {
                                                          attrs: {
                                                            icon: "ClipboardIcon",
                                                            size: "18",
                                                          },
                                                        }),
                                                        _vm._v(" Download "),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "outline-secondary" },
                            on: { click: row.toggleDetails },
                          },
                          [_vm._v(" Hide Details ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }